import { FC, ReactNode } from 'react';
import { FieldProps, RecordContextProvider, useGetOne, useRecordContext } from 'react-admin';

interface ReferenceSingleFieldProps extends FieldProps {
  children: ReactNode;
  reference: string;
  source: string;
  query?: Record<string, unknown>;
  'data-testid'?: string;
}

export const ReferenceSingleField: FC<ReferenceSingleFieldProps> = ({
  children,
  reference,
  source,
  query,
  ...rest
}) => {
  const record = useRecordContext(rest);
  const { data } = useGetOne(
    reference,
    {
      id: !!record && !!record[source] ? record[source] : 0,
      meta: {
        query,
      },
    },
    { enabled: !!record && !!record[source] },
  );

  if (!data) {
    return null;
  }

  return (
    <RecordContextProvider value={data}>
      <>{children}</>
    </RecordContextProvider>
  );
};
